import { CommonModule } from '@angular/common';
import { Component, DOCUMENT, Renderer2, inject, input, output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FilterSelection } from 'src/app/components/filters/filters.component';
import { CategoryLayoutData } from 'src/app/core/interfaces/store-configuration.interface';
import { DropdownItem } from 'src/app/core/models/dropdown.model';
import { MappedFilter } from 'src/app/products/services/filters-adapter.service';
import { LAYOUT_TYPE } from '../../enum/category-page.enum';

import { BrowserApiService } from 'src/app/core/services/browser-api/browser-api.service';
import { DeviceDetectionService } from 'src/app/core/services/device-detection/device-detection.service';
import { PlatformService } from 'src/app/core/services/platform/platform.service';
import { CategoryFilterLayout1Component } from "../category-filter-layout-1/category-filter-layout-1.component";
import { CategoryFilterLayout2Component } from "../category-filter-layout-2/category-filter-layout-2.component";


export enum GridViewLayout {
  // for square layout
  GRID_VIEW_LAYOUT1 = "gridViewLayout1",
  GRID_VIEW_LAYOUT2 = "gridViewLayout2",
  // for rectangular view
  GRID_VIEW_LAYOUT3 = "gridViewLayout3",
  GRID_VIEW_LAYOUT4 = "gridViewLayout4"
}

const SORT_OPTIONS = ['Newest', 'High Price', 'Low Price'];

@Component({
  standalone: true,
  selector: 'sorting-layout-1',
  templateUrl: './sorting-layout-1.component.html',
  styleUrls: ['./sorting-layout-1.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, CategoryFilterLayout1Component, CategoryFilterLayout2Component]
})
export class SortingLayout1Component {
  private renderer = inject(Renderer2);
  private document = inject<Document>(DOCUMENT);
  private platformService = inject(PlatformService);
  private browserApiService = inject(BrowserApiService);
  private readonly deviceDetectionService = inject(DeviceDetectionService);


  LAYOUT_TYPE = LAYOUT_TYPE;
  isHamburgerMenu = false;

  // Update inputs to use new Angular input() function
  totalProductsCount = input<number>(0);
  fetchedProductsCount = input<number>(0);
  sortBy = input<string>('');
  sortOptions = input<DropdownItem<string>[]>([]);
  categoryLayoutData = input<CategoryLayoutData>({
    categoryLayoutConfig: {
      categoryLayoutType: '',
      themeBackgroundColor: '',
      themeFontFamily: ''
    },
    bannerConfiguration: {},
    filterData: {
      mainConfiguration: {},
      styleConfiguration: {
        desktopStyleConfiguration: {} as any,
        mobileStyleConfiguration: {} as any
      },
      advanceConfiguration: {}
    },
    toolBarData: {} as any,
    paginationData: {} as any,
    productCardData: {} as any
  });

  // Expose device detection service signals for template usage
  get isMobileDevice() { return this.deviceDetectionService.isMobile; }
  get isDesktop() { return this.deviceDetectionService.isDesktop; }
  get isTablet() { return this.deviceDetectionService.isTablet; }
  get deviceType() { return this.deviceDetectionService.deviceType; }

  category = input<string>('');

  availableFilterAttributes = input<MappedFilter[] | null>([]);
  currentAppliedFilters = input<FilterSelection[] | null>([]);

  gridViewLayout = GridViewLayout;

  selectedGridViewLayout = input<string>('');
  SORT_OPTIONS = SORT_OPTIONS;
  backgroundColor = "";



  // Update outputs to use Angular 20 output() function
  selectedGridViewLayoutChange$ = output<GridViewLayout>();
  mobileFilterOpened$ = output<boolean>();
  sortByChange$ = output<string>();

  changeItemGridView(gridViewLayout: GridViewLayout) {
    this.selectedGridViewLayoutChange$.emit(gridViewLayout);
  }

  toggleHamburgerMenu() {
    this.isHamburgerMenu = !this.isHamburgerMenu;
    this.mobileFilterOpened$.emit(this.isHamburgerMenu);
    if (this.isHamburgerMenu) {
      if (this.platformService.isBrowser()) {
        this.browserApiService.scrollTo({ top: 0, left: 0 });
      }
      this.renderer.setStyle(this.document.body, 'overflow', 'hidden');
    } else {
      this.renderer.removeStyle(this.document.body, 'overflow');
    }
  }

  onSortChange(event: any) {
    const sortValue = event.target.value;
    this.sortByChange$.emit(sortValue); // Always emit, even if empty
  }

  getMobileFilterBackground() {
    if (!this.backgroundColor) {
      const filterBackgroundSection = this.document.getElementsByClassName("filter-layout-background")?.[0];
      this.backgroundColor = '#ffffff'
      if (filterBackgroundSection) {
        const currentBackgroundColor = getComputedStyle(filterBackgroundSection).backgroundColor;
        this.backgroundColor = currentBackgroundColor ? currentBackgroundColor : '#ffffff';
      }
    }
    return this.backgroundColor;
  }
}





